"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableOptions = /** @class */ (function () {
    function TableOptions() {
        this._options = new Map();
        this._info = new Map();
    }
    TableOptions.prototype.add = function (index, option) {
        this._options.set(index, option);
        return this;
    };
    TableOptions.prototype.get = function (index) {
        return this._options.get(index);
    };
    TableOptions.prototype.setRowsCount = function (rowsCount) {
        this._rowsCount = rowsCount;
        return this;
    };
    Object.defineProperty(TableOptions.prototype, "rowsCount", {
        get: function () {
            return this._rowsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableOptions.prototype, "options", {
        get: function () {
            return this._options;
        },
        enumerable: true,
        configurable: true
    });
    TableOptions.prototype.setInfo = function (value) {
        this._info = value;
        return this;
    };
    Object.defineProperty(TableOptions.prototype, "info", {
        get: function () {
            return this._info;
        },
        enumerable: true,
        configurable: true
    });
    return TableOptions;
}());
exports.TableOptions = TableOptions;
//# sourceMappingURL=table-options.js.map